module.exports = __webpack_public_path__ + "img/btn-home-en.bf9fb643.png";